import { DefaultWebItemAnimator } from "../../../web/itemanimators/DefaultWebItemAnimator";
export { DefaultWebItemAnimator as DefaultJSItemAnimator };
